import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  ABOUT_DETAIL_FETCH,
  ABOUT_DETAIL_SUCCESS,
  ABOUT_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { ABOUT_FORM_NAME } from '../AboutForm/constants';

//<<<---ABOUT-DETAIL--->>>
export const aboutDetailFetch = createAction(ABOUT_DETAIL_FETCH);
export const aboutDetailSuccess = createAction(ABOUT_DETAIL_SUCCESS);
export const aboutDetailFailure = createAction(ABOUT_DETAIL_FAILURE);

export const fetchAboutDetail = (id, lang) => async dispatch => {
  dispatch(aboutDetailFetch());
  try {
    const { data } = await api.get(`about/${id}/${lang}`);

    const fieldNames = [
      'id',
      'title',
      'description',
      'header',
      'headerImageSmall',
      'image',
      'slug',
      'subtitle',
      'content'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(ABOUT_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(ABOUT_FORM_NAME, 'headerImageLarge', {
        src: `https://api.alfadent.ikiguys.net${data.headerImageLarge}`
      })
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(aboutDetailSuccess());
  } catch (error) {
    dispatch(aboutDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/AboutDetail/actions.js